Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.AppliedFilterValueView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/filters/applied/applied_filter_value']
  className: 'applied-filter-value-container'

  initialize: ({value}) ->
    @value = value

  render: ->
    @$el.empty().append @template
      value: @value
    @
